import {
  Heading1,
  Heading2,
  Heading3
} from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { container, spacing } from '../../../theme';

export const StyledTermsOfUse = styled.div`
  padding: ${spacing('xl4')} ${spacing('md')};
  max-width: ${container('md')};
  margin: auto;

  ${Heading1} {
    text-align: center;
    margin-bottom: ${spacing('xl')};
  }

  ${Heading2} {
    text-transform: uppercase;
    &:not(:first-of-type) {
      margin-top: ${spacing('xl3')};
    }
  }

  ${Heading3} {
    margin-top: ${spacing('md')};
  }

  ul,
  ol {
    margin-bottom: ${spacing('xl')};
  }

  ul li,
  ol li {
    list-style-type: disc;
    margin-left: ${spacing('xl')};
    margin-bottom: ${spacing('sm')};
  }

  ol li {
    list-style-type: numeric;
  }
`;
